import { create } from "zustand";

interface PrivacySessionState {
  token: string | null;
  expiresAt: number | null;
  lockVersion: number;
  unlock: (token: string, expiresAt: number) => void;
  clear: () => void;
}

/** 仅在当前标签页内存中保存；不要持久化隐私令牌。 */
export const usePrivacySessionStore = create<PrivacySessionState>((set) => ({
  token: null,
  expiresAt: null,
  lockVersion: 0,
  unlock: (token, expiresAt) => set({ token, expiresAt }),
  clear: () => set((state) => ({ token: null, expiresAt: null, lockVersion: state.lockVersion + 1 })),
}));

export function getActivePrivacyToken(): string | null {
  const { token, expiresAt } = usePrivacySessionStore.getState();
  return token && expiresAt && expiresAt > Date.now() ? token : null;
}
